import React from 'react'
import { AccordionContainer } from '../../common/components/accordion/accordion.module';
import { InputContainer } from '../../common/components/form/input/containers/input.container';

export default function TenantEnableNPSubscriptionInfoComponent ({enableSubscription,programs,handleInnerFormChange,}: any) {

  return (
    <>
       <AccordionContainer
           child={
             <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            
       <InputContainer
                     label="Program Name"
                     labelField="Name"
                     list={programs}
                     onValueChange={(event: any) => {
                         handleInnerFormChange(event.target.value, 'OwnerId');
                       }
                     }
                     optionName='choose Programs'
                     type="select"
                     value={enableSubscription?.OwnerId}
                     valueField="Id"
                   />
       
       
       
         </div>
         }
         expandedPanel="basicInfo"
         headerTitle="Basic Info"
       />
      

    </>
  )
}